import { defineComponent as _defineComponent } from 'vue'
import newBuilderSelect from './new-builder-select.vue';
import addBuilder from './add-builder.vue';
import editBuilder from './edit-builder.vue';
import startRegistration from "./start-registration.vue";
import { onMounted, onUnmounted, ref, watch } from 'vue';
import { toggleCollapse, isMobile, collapsed } from '../navState';
import { useAuth } from '@/store/auth';

// import { useUserstate } from '@/store/userstate';
// import { UserState } from '@busy-human/hxp-library';
import { useShoppingBuilderStore } from '@/store/builder-shopping';
import emitter, { EventTypes, events } from '@/events';
import AuthPopup from "@/components/Signup-login/auth-popup.vue";

// const bookings = useBookings();
// const router = useRouter();
// const userstate = useUserstate();


enum navState {
	SELECT_BUILDER = 0,
	ADD_BUILDER = 1,
	EDIT_BUILDER = 2,
	START_REGISTRATION = 3
}


export default /*#__PURE__*/_defineComponent({
  __name: 'shopping-nav',
  setup(__props, { expose: __expose }) {
  __expose();

const builderStore = useShoppingBuilderStore();

const state = ref(navState.SELECT_BUILDER);

const auth = useAuth();

const showAuthPopup = ref(false);

const shouldFullClose = ref(false);

const openEditBuilder = (builderId: string, fullClose = false) => {
	if (builderStore.builders?.[builderId]) {
		shouldFullClose.value = fullClose;
		state.value = navState.EDIT_BUILDER;
		builderStore.selectBuilder(builderId);
	} else {
		console.warn('Unable to find builder for builder id: ', builderId);
	}
};

function closeEditBuilder() {
	state.value = navState.SELECT_BUILDER;
	if (shouldFullClose.value) {
		toggleCollapse(true);
	}
}

const editBuilderEventFunc = (builderId: any) => {
	if (typeof builderId !== 'string') return;

	if (collapsed.value) { toggleCollapse(); }
	openEditBuilder(builderId, true);
};

const addToParent = ref<string | undefined>();
const addBuilderEventFunc = (parentId: string | void) => {
	if (collapsed.value) { toggleCollapse(); }
	if(parentId) {
		addToParent.value = parentId;
	} else {
		addToParent.value = undefined;
	}
	state.value = navState.ADD_BUILDER;
};

const startRegistrationEventFunc = () => {
	if (collapsed.value) { toggleCollapse(); }
	state.value = navState.START_REGISTRATION;
};

onMounted(() => {
	events.on(EventTypes.editBuilder, editBuilderEventFunc);
	events.on(EventTypes.addBuilder, addBuilderEventFunc);
	events.on(EventTypes.startRegistration, startRegistrationEventFunc);
});

onUnmounted(() => {
	events.off(EventTypes.editBuilder, editBuilderEventFunc);
	events.off(EventTypes.addBuilder, addBuilderEventFunc);
	events.off(EventTypes.startRegistration, startRegistrationEventFunc);
});

// ============ Move To Functions =============

watch(() => state.value, s => {
	if (s === navState.ADD_BUILDER || s === navState.EDIT_BUILDER) {
		emitter.emit("hideWelcomeBack", true);
	} else {
		emitter.emit("hideWelcomeBack", false);
	}
});

function openWelcomeBack(){
    emitter.emit('openWelcomeBack');
}


const __returned__ = { builderStore, navState, state, auth, showAuthPopup, shouldFullClose, openEditBuilder, closeEditBuilder, editBuilderEventFunc, addToParent, addBuilderEventFunc, startRegistrationEventFunc, openWelcomeBack, newBuilderSelect, addBuilder, editBuilder, startRegistration, onMounted, onUnmounted, ref, watch, get toggleCollapse() { return toggleCollapse }, get isMobile() { return isMobile }, get collapsed() { return collapsed }, get useAuth() { return useAuth }, get useShoppingBuilderStore() { return useShoppingBuilderStore }, get emitter() { return emitter }, get EventTypes() { return EventTypes }, get events() { return events }, AuthPopup }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})